import React from 'react';
import { Link } from 'react-router-dom';

const PrivacyPolicy = () => {
  return (
    <div className="min-h-screen bg-[#040F1E] text-white">
      <style>{`
        @import url('https://fonts.googleapis.com/css2?family=Syne:wght@400;600;700;800;900&family=DM+Sans:wght@400;500;600;700;800&display=swap');
        .font-syne { font-family: 'Syne', sans-serif; }
        .font-dm { font-family: 'DM Sans', sans-serif; }
      `}</style>

      <div className="max-w-3xl mx-auto px-4 sm:px-6 py-12">
        <Link to="/" className="font-syne text-3xl font-extrabold text-[#00C4B4] mb-8 inline-block" style={{ letterSpacing: '-1.5px' }}>TAGO</Link>

        <h1 data-testid="privacy-heading" className="font-syne text-4xl font-extrabold text-white mb-2">Privacy Policy</h1>
        <p className="text-white/40 text-sm font-dm mb-10">Last updated: February 2026</p>

        <div className="space-y-8 font-dm text-white/80 leading-relaxed">
          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">1. Introduction</h2>
            <p>TAGO ("we," "our," or "us") operates the tago.bot website and QR-based vehicle contact service. This Privacy Policy explains how we collect, use, disclose, and safeguard your information when you use our Service. By using TAGO, you agree to the collection and use of information in accordance with this policy.</p>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">2. Information We Collect</h2>
            <p className="mb-3"><strong className="text-white">Account Information:</strong> When you register, we collect your name, email address, phone number, and password. If you sign in via Google, we receive your name, email, and profile picture from Google.</p>
            <p className="mb-3"><strong className="text-white">Vehicle Information:</strong> Vehicle labels, plate numbers (optional), and the phone number you choose to associate with each vehicle QR code.</p>
            <p className="mb-3"><strong className="text-white">Scan & Contact Logs:</strong> When someone scans a QR code, we record the timestamp and the reason selected for contact. We do not collect the scanner's personal information.</p>
            <p><strong className="text-white">Waitlist Data:</strong> If you join our waitlist, we collect the information you voluntarily provide (name, email, phone, city).</p>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">3. How We Use Your Information</h2>
            <ul className="list-disc list-inside space-y-2 ml-2">
              <li>To provide, operate, and maintain the TAGO service</li>
              <li>To display your phone number to those who scan your vehicle's QR code (only after they select a reason and tap to reveal)</li>
              <li>To send you service-related communications</li>
              <li>To improve and optimize our service</li>
              <li>To detect and prevent fraud or abuse</li>
            </ul>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">4. Data Sharing</h2>
            <p>We do not sell, rent, or trade your personal information. Your phone number is shared only when someone scans your vehicle's QR code and actively requests to see it. We may share data with service providers who assist in operating our platform, or when required by law.</p>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">5. Data Security</h2>
            <p>We implement industry-standard security measures to protect your information. However, no electronic transmission or storage method is 100% secure. We cannot guarantee absolute security of your data.</p>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">6. Data Retention</h2>
            <p>We retain your personal information for as long as your account is active or as needed to provide services. You may request deletion of your account and associated data at any time by contacting us.</p>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">7. Your Rights</h2>
            <p>You have the right to access, update, or delete your personal information. You may update your account details through the dashboard or contact us for data deletion requests.</p>
          </section>

          <section>
            <h2 className="font-syne text-xl font-bold text-white mb-3">8. Contact Us</h2>
            <p>If you have questions about this Privacy Policy, please contact us at <a href="mailto:tago.bots@gmail.com" className="text-[#00C4B4] hover:underline">tago.bots@gmail.com</a>.</p>
          </section>

          <div className="bg-[#FF6B35]/10 border border-[#FF6B35]/20 rounded-xl p-4 mt-8">
            <p className="text-sm text-[#FF6B35] font-semibold">This application is currently in Beta. Features, terms, and data handling practices may change as we continue to improve the service.</p>
          </div>
        </div>

        <div className="mt-12 pt-8 border-t border-[rgba(0,196,180,.14)] flex items-center justify-between">
          <span className="text-xs text-white/30">© 2026 TAGO · Kingdom of Bahrain</span>
          <Link to="/terms" className="text-sm text-[#00C4B4] hover:underline font-dm">Terms of Service</Link>
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
